import { render, staticRenderFns } from "./RelocationOfChildBestInterestsOfChild.vue?vue&type=template&id=14f3a60c"
import script from "./RelocationOfChildBestInterestsOfChild.vue?vue&type=script&lang=ts"
export * from "./RelocationOfChildBestInterestsOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports